import { Component, EventEmitter, Input, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormDto } from '../../../models/ortak.dtos';
import { DxButtonModule, DxFormComponent, DxFormModule, DxToolbarModule } from 'devextreme-angular';
import { BysBelgeNot } from '@dabnet-kamu/libs/bys/models/bys.models';
import { PdfViewService } from '../pdf-view.service';
import { Subject, takeUntil } from 'rxjs';
import { ValidationService } from '../../../services/validation.service';
import { UtilsService } from '../../../services/utils.service';
import { CtGenLookupComponent } from '../../ct-gen-lookup/ct-gen-lookup.component';
import { CtGenRadioBtnComponent } from '../../ct-gen-radio-btn/ct-gen-radio-btn.component';
import { alert } from 'devextreme/ui/dialog';

@Component({
  selector: 'dk-pdf-view-belge-not-crud-popup',
  standalone: true,
  imports: [CommonModule,DxButtonModule,DxToolbarModule,CtGenRadioBtnComponent,DxFormModule],
  templateUrl: './pdf-view-belge-not-crud-popup.component.html',
  styleUrls: ['./pdf-view-belge-not-crud-popup.component.scss'],
})
export class PdfViewBelgeNotCrudPopupComponent {

  @ViewChild(DxFormComponent, { static: false }) form: DxFormComponent;
  @ViewChildren(CtGenRadioBtnComponent) radioButtons: QueryList<CtGenRadioBtnComponent>;

  @Input() formMetaData:FormDto;
  @Input() selectedRow:BysBelgeNot;
  @Output() closePopup = new EventEmitter<any>();


  state:string = 'New';
  isLoading:boolean = false;

  validationRulesMap: { [key: string]: any[] } = {};

  private destroy$ = new Subject<void>();


  constructor(public pdfViewService:PdfViewService,
    private validationService:ValidationService,
    private utilsService:UtilsService
  ){

  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(){

     this.pdfViewService.gridControlsListNot$
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        if (res?.fields && !Object.keys(this.validationRulesMap).length) {
          this.validationRulesMap =
            this.validationService.initializeValidationRules(res.fields);
            if(this.state === 'New'){
              this.selectedRow = this.validationService.setRequiredFieldsToNullIfEmpty(this.validationRulesMap, this.selectedRow);
            }
            this.validationService.isFormValid(this.form, null, null,this.radioButtons);
        }
      });

  }


  handleSaveClick(){
    if(!this.validationService.isFormValid(this.form,null,null,this.radioButtons)){
      alert('Lütfen formu uygun şekilde doldurun!','Uyarı');
      return;
    }

    if(this.state == 'New'){
      this.insertBysBelgeNot();

    }else{
      alert('Form güncelleme işlemine kapalıdır!','Uyarı');
    }

  }


  handleCancelClick(){
    this.closePopup.emit();

  }


  insertBysBelgeNot(){
    if (this.formMetaData.formYetki.insertYn) {
      this.isLoading = true;
      this.pdfViewService
        .insertBysBelgeNot(this.selectedRow)
        .then(
          () => {
            this.isLoading = false;
            this.utilsService.showSuccess('İşlem Başarılı');
            this.closePopup.emit('insert');
          },
          (err) => {
            this.isLoading = false;
            this.utilsService.showError(err);
          }
        );
    }else{
      alert('Kayıt eklemek için yetkiniz yok!','Yetki Uyarısı');
    }
  }
}
